import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 w-1/3 border-t-2 border-accent" }, null, -1)
const _hoisted_3 = { class: "mt-2 text-xs uppercase tracking-wider" }
const _hoisted_4 = { class: "mt-4 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isMain ? 'col-span-full': '')
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.post.language[_ctx.language].title), 1),
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.Utils.formatDate(
            _ctx.post.language[_ctx.language].createdAt
        )), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.post.language[_ctx.language].preview), 1),
    _createElementVNode("button", {
      class: "flex mt-4 bg-accent px-6 py-2 max-w-min",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPost()))
    }, "More")
  ], 2))
}